<template>
    <div>
        <div
            @mouseover="onHoverProfileImage = true"
            @mouseleave="onHoverProfileImage = false"
            class="profile-image"
            @click="
                !isLoadingModal &&
                    details.isactive &&
                    _hasAccess('setting.staff.update') &&
                    uploadPhoto()
            "
        >
            <img
                v-if="isPhotoAvailable"
                class="photo"
                :src="details.photo_path"
            />
            <div v-else class="photo-placeholder">
                <i class="cus-user-profile"></i>
            </div>
            <div class="image-upload-icon">
                <i v-show="!onHoverProfileImage" class="cus-camera-upload"></i>
                <i
                    v-show="onHoverProfileImage"
                    class="cus-camera-upload-black"
                ></i>
            </div>
        </div>

        <div class="pt-3">
            <div
                class="tab nav-text font-weight-bold"
                :class="{ 'active-tab': staffProfileTab !== 'time_sheet' }"
                @click="changeTab('profile')"
            >
                <span>Profile</span>
            </div>
        </div>
        <div v-if="isHasPermissionToViewTimesheet">
            <div
                class="tab nav-text font-weight-bold"
                :class="{ 'active-tab': staffProfileTab == 'time_sheet' }"
                @click="changeTab('time_sheet')"
            >
                <span>Time Sheets</span>
            </div>
        </div>
        <hr v-if="isCurrentActorProfile && isNotifcationFeatureEnabled" />
        <div v-if="isCurrentActorProfile && isNotifcationFeatureEnabled">
            <div class="nav-text font-weight-bold" @click="goToNotificationSettings">
                Notification Settings
                <i
                    class="fas fa-long-arrow-alt-right pl-2"
                    style="color: #cccccc"
                ></i>
            </div>
        </div>
        <hr />
        <div>
            <div
                class="nav-text font-weight-bold"
                v-if="details.isactive && _hasAccess('setting.staff.reset')"
                @click="
                    !isLoadingModal &&
                        details.isactive &&
                        _hasAccess('setting.staff.reset') &&
                        resetPassword()
                "
            >
                Reset Password
            </div>
        </div>
        <div>
            <spinner v-if="isLoadingModal" class="nav-text"></spinner>
            <div
                v-else-if="
                    !isLoadingModal &&
                    details.isactive &&
                    _hasAccess('setting.staff.delete')
                "
                class="nav-text"
                @click="deactivateStaff"
            >
                Deactivate
            </div>
            <div
                v-else-if="
                    !isLoadingModal &&
                    !details.isactive &&
                    _hasAccess('setting.staff.update')
                "
                class="nav-text font-weight-bold"
                @click="deactivateStaff"
            >
                Reactivate
            </div>
        </div>

        <modal-is-deactivate-staff
            ref="isDeactivateModal"
            @update-complete="refreshPage"
        />
        <modal-dialog
            ref="modalDialog"
            :confirmBtnTxt="`Reset`"
            :isLoading="isLoading"
            @confirm-dialog="confirmResetPassword()"
        >
            <template v-slot:title>Reset Password</template>
            <template v-slot:body>
                Please confirm that you wish to reset password for
                <b>{{ details.fullname }}</b
                >?
            </template>
        </modal-dialog>
        <modal-upload-photo ref="modalUploadPhoto" />
    </div>
</template>

<script>
import staffService from "@/services/staff";
import ModalDialog from "@/components/commons/modal-dialog";
import ModalIsDeactivateStaff from "@/components/setting-staff/modal-is-deactivate-staff.vue";
import Spinner from "@/components/elements/spinner.vue";
import { STAFF_PROFILE_TAB_OPTIONS } from "@/store/staff.js";
import FeaturesEnabledMixin from "@/mixins/features-enabled";
import modalUploadPhoto from "@/components/client-photos/photo-upload-modal";
import EXTENSIONS from "@/constants/extensions";

export default {
    components: {
        ModalIsDeactivateStaff,
        ModalDialog,
        Spinner,
        modalUploadPhoto
    },
    data() {
        return {
            isLoading: false,
            isLoadingModal: false,
            onHoverProfileImage: false
        };
    },
    mixins: [FeaturesEnabledMixin],
    computed: {
        currentActor() {
            return this.$root.currentActor;
        },
        isCurrentActorProfile() {
            if (
                this.currentActor &&
                this.details &&
                this.currentActor.id == this.details.id
            ) {
                return true;
            } else {
                return false;
            }
        },
        details() {
            return this.$store.getters["staff/staffDetails"];
        },
        refresh() {
            return this.$store.getters["staff/refresh"];
        },
        staffProfileTab() {
            return this.$store.getters["staff/staffProfileTab"];
        },
        isHasPermissionToViewTimesheet() {
            if (!this._isExtensionEnabled(EXTENSIONS.CODE.CODE_TIME_CLOCK)) {
                return false;
            }

            return this.isCurrentActorProfile ||
                this._hasAccess("setting.time_sheet.edit") ||
                this._hasAccess("setting.time_sheet.delete")
                ? true
                : false;
        },
        isPhotoAvailable() {
            return (
                this.details.photo_path &&
                !this.details.photo_path.includes("no_avatar.png")
            );
        }
    },
    created() {},
    mounted() {},
    beforeDestroy() {},
    methods: {
        async deactivateStaff() {
            this.isLoadingModal = true;
            await this.$refs.isDeactivateModal.open(
                this.details.id,
                this.details.fullname,
                this.details.isactive
            );
            this.isLoadingModal = false;
        },
        refreshPage() {
            this.$store.commit("staff/setRefresh", this.refresh + 1);
            this.$store.commit(
                "staff/setStaffProfileTab",
                STAFF_PROFILE_TAB_OPTIONS.profile
            );
        },
        changeTab(tab) {
            if (this.checkIfEditingStaff()) return;
            this.$store.commit("staff/setStaffProfileTab", tab);
        },
        async confirmResetPassword() {
            this.isLoading = true;
            let reset = await staffService.getResetPassword(this.details.id);
            const { status, data } = reset;
            if (reset && status == 200) {
                if (data?.response?.resource?.message) {
                    this._message(data.response.resource.message);
                }
            } else {
                this._message(`Error: Cannot Reset Staff Password`);
            }
            this.$refs.modalDialog.close();
            this.isLoading = false;
        },
        resetPassword() {
            this.$refs.modalDialog.open();
        },
        checkIfEditingStaff() {
            if (this.staffProfileTab === STAFF_PROFILE_TAB_OPTIONS.edit) {
                if (
                    confirm(
                        "You are editing staff's profiles currently. Discard your changes?"
                    )
                ) {
                    // NOTE: Discard changes editing staff
                    return false;
                } else {
                    // NOTE: Stay editing staff profile
                    return true;
                }
            }
        },
        goToNotificationSettings() {
            this.$router.push({
                name: "notifications-setting"
            });
        },
        uploadPhoto() {
            let module = "STAFF";
            this.$refs.modalUploadPhoto.open(module);
        }
    }
};
</script>

<style lang="scss" scoped>
.photo {
    /* width: 230px; */
    width: 100%;
    padding: 4px;
    background-color: #fff;
    border: 1px solid #ccc;
    border: 1px solid rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.tab {
    cursor: pointer;
    border-radius: 5px;
}

.active-tab {
    background-color: #caccde;
}

.nav-text {
    cursor: pointer;
    font-size: 14px;
    padding: 10px;
}

.nav-text:hover {
    border-radius: 5px;
    background: #c9ccde;
    cursor: pointer;
}

.profile-image {
    cursor: pointer;
    position: relative;

    .photo-placeholder {
        width: 100%;
        border: #cccccc solid 1px;
        display: flex;
        justify-content: center;
        padding-top: 40px;
        padding-bottom: 40px;

        .cus-user-profile {
            height: 140px !important;
            width: 140px !important;
            margin: 0px !important;
            background-position: center;
        }
    }

    .image-upload-icon {
        position: absolute;
        bottom: 0;
        right: 0;
        padding: 6px 10px;
    }

    .cus-camera-upload,
    .cus-camera-upload-black {
        height: 26px !important;
        width: 26px !important;
        margin: 0px !important;
    }
}
</style>
